// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/admin/invitations/styles.scss
// module id = 958
// module chunks = 0